import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="14" height="8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7 6.293L1.354.646l-.708.708L7 7.707l6.354-6.353-.707-.708L7 6.293z" /></svg>;